module.exports = __webpack_public_path__ + "img/success.6ffe5065.png";